export enum CommercialProgram {
  FullDayClasses = 1,
  ExtendedStay = 2,
}
